import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { API, api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Invite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user, loading } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    axios.get(`${API}/invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Invite not found"));
  }, [token]);

  const accept = async () => {
    setAccepting(true);
    try {
      const r = await api.post(`/invites/${token}/accept`);
      toast.success(`Linked with ${r.data.coach_name}`);
      nav("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not accept");
    } finally { setAccepting(false); }
  };

  if (err) return (
    <div className="max-w-md mx-auto mt-16 text-center">
      <div className="rs-underline mx-auto mb-4" />
      <h1 className="font-display-heavy text-3xl">INVITE UNAVAILABLE</h1>
      <p className="text-neutral-400 mt-3">{err}</p>
      <Link to="/"><Button className="mt-6 h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">Go home</Button></Link>
    </div>
  );
  if (!info) return <div className="text-neutral-400">Loading…</div>;

  const expired = info.invite.status !== "pending";

  return (
    <div className="max-w-md mx-auto mt-16">
      <div className="rs-underline mb-4" />
      <div className="border border-neutral-800 rounded-md bg-neutral-900 p-8">
        <div className="uppercase text-xs text-red-500 font-display tracking-widest">Coach Invite</div>
        <h1 className="font-display-heavy text-3xl mt-2">{info.coach_name.toUpperCase()} WANTS TO COACH YOU</h1>
        <p className="text-neutral-300 mt-4">Accept to give them read-only access to your training plan and drills. Your videos stay private.</p>
        <p className="text-neutral-500 text-sm mt-2">Invited: <span className="text-white">{info.invite.email}</span></p>
        {expired && <p className="text-red-500 mt-4">This invite is {info.invite.status}.</p>}
        {loading ? null : !user ? (
          <div className="mt-8 space-y-3">
            <p className="text-sm text-neutral-400">Sign in or create your athlete account to accept.</p>
            <Link to={`/register?invite=${token}&email=${encodeURIComponent(info.invite.email)}`}><Button data-testid="invite-signup-btn" className="w-full h-12 bg-red-600 hover:bg-red-700 font-semibold">Create account & accept</Button></Link>
            <Link to={`/login?invite=${token}`}><Button data-testid="invite-login-btn" variant="outline" className="w-full h-12 border-neutral-700 text-white hover:bg-neutral-800">I already have an account</Button></Link>
          </div>
        ) : (
          <Button data-testid="invite-accept-btn" disabled={expired || accepting} onClick={accept} className="w-full mt-8 h-12 bg-red-600 hover:bg-red-700 font-semibold">
            {accepting ? "Accepting…" : "Accept invite"}
          </Button>
        )}
      </div>
    </div>
  );
}
